import type { Pass, PassType } from '@/types';
import { calculateEndDate, getTodayForInput } from '@/shared/lib/calendarDate';

interface CreatePassDraftOptions {
  id?: string;
  now?: Date;
}

export const createPassDraftFromTemplate = (
  template: PassType,
  options: CreatePassDraftOptions = {}
): Pass => {
  const { id = Date.now().toString(), now } = options;
  const today = getTodayForInput(now);
  const calculatedEndDate = template.duration ? calculateEndDate(today, template.duration) : null;

  return {
    id,
    name: template.name,
    startsAt: today,
    endsAt: calculatedEndDate,
    credits:
      template.credits !== null
        ? {
            remainingCredits: template.credits,
            maxCredits: template.credits,
          }
        : null,
  };
};
